/**
 * Preloads images after paint by constructing Image objects.
 *
 * Belongs here: the existing usePreloadImages behaviour.
 * Does not belong here: link preload. That is preloadImage.ts.
 */
import { useEffect } from 'react'

export const usePreloadImages = (imgSrcs: string[]) => {
  const preloadImage = (imgSrc: string) => {
    try {
      const img = new Image()
      img.src = imgSrc
      // @ts-ignore
      window[imgSrc] = img
    } catch {}
  }

  useEffect(() => {
    imgSrcs?.forEach((imgSrc) => {
      preloadImage(imgSrc)
    })
  }, [])
}
